import {
    FETCH_ASSETSETTINGS_BEGIN,
    FETCH_ASSETSETTINGS_SUCCESS,
    FETCH_ASSETSETTINGS_FAILURE,
    FETCH_BENCHMARKENTITIES_BEGIN,
    FETCH_BENCHMARKENTITIES_SUCCESS,
    FETCH_BENCHMARKENTITIES_FAILURE
} from '../constants/assetsettings';

const initialState = {
    assetSetting: {},
    benchMarkEntities: [],
    isLoading: false,
    error: "",
    additionalBM:[]
}


export const getAssetSettingsReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ASSETSETTINGS_BEGIN: {
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_ASSETSETTINGS_SUCCESS:
            
            return {
                ...state,
                isLoading: false,
                assetSetting: payload.settingsDetails,
              
            };
        case FETCH_ASSETSETTINGS_FAILURE:
            return {
                ...state,
                error: payload.error,
                isLoading: true,
            };

        //benchmark entities Data cases
        case FETCH_BENCHMARKENTITIES_BEGIN: {
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_BENCHMARKENTITIES_SUCCESS:
            if(payload.type=="AdditionalbenchMark")
            return {
                ...state,
                isLoading: false,
                additionalBM:payload.benchMarkEntities
            };
            if(payload.type=="benchMark")
            return {
                ...state,
                isLoading: false,
                benchMarkEntities: payload.benchMarkEntities,
            };
        case FETCH_BENCHMARKENTITIES_FAILURE:
            return {
                ...state,
                error: payload.error,
                isLoading: true,
            };

        //default case
        default:
            return state;
    }
}

export default getAssetSettingsReducer;
